import React from 'react'

import { SchoolParams } from '../types/common'

const schoolParams: SchoolParams = {
  params: { school: '', district: '' },
  match: '',
}

const RouteContext = React.createContext<SchoolParams>(schoolParams)

export default RouteContext
